class Chromication {
    constructor() {
        this.filter = 1;
    }
}

module.exports = Chromication;